import type { Borrower } from "@/lib/types";
import { readBorrowers } from "./store";

export async function listBorrowers(): Promise<Borrower[]> {
  return readBorrowers();
}

export async function getBorrower(borrowerId: string): Promise<Borrower | null> {
  return (await readBorrowers()).find((entry) => entry.id === borrowerId) ?? null;
}
